import axios from 'axios';
import qs from 'qs';
import { URL, TOKEN } from '../utils/const';

export const unMount = async (tipo, id, setImponible, setEtapa) => {

  if (!id) {
    return null
  }
  const data = await consultarPartida(id, setEtapa)
  await getImponible(tipo, id, setImponible)

}

export const getImponible = async (tipo, id, setImponible) => {
    try {
        /* Consulta de imponible */
        let longitud = id.length;
        let id_partida = id;
        let id_nomenclatura = "";
        if(longitud === 15){
            let id_temp = id.slice(0,2) + "-" + id.slice(2,4) + "-" + id.slice(4,7) + "-" +id.slice(7,11) + "-" + id.slice(11,15);
            id_nomenclatura = id_temp;
        }else if(longitud === 7){
            id_partida = id;
        }
        //console.log("id_nomen, id_partida", [id_nomenclatura, id_partida]);
        const imponible = await axios({
            method: 'post',
            url: URL + 'consulta_imponible',
            data: qs.stringify({
                TOKEN: TOKEN,
                IMPONIBLE_TIPO: tipo,
                IMPONIBLE_IDENTIFICACION: id_partida,
                IMPONIBLE_NOMBRE: id_nomenclatura,
            }),
            headers: {
                'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
            },
        });

        if (imponible.data.error) return setImponible(imponible.data);

       return setImponible(imponible.data.items[0])
    } catch (error) {
        return -1;
    }
};

export const consultarPartida = async(partida, setEtapa) => {

  try {
    const response  = await axios({
      method: 'get',
      url: 'https://webservice.muninqn.gov.ar/admin/api/beneficio_partida/' + partida,
     
      
  });
  
  setEtapa('dos')
  /* if (response.data.data && response.data.data.etapa === 2) {
  }else{
    setEtapa('uno')
  } */
} catch (error) {
  
  setEtapa('dos')
  }
}